import { Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { FacialRecognitionStepComponent } from '../facial-recognition-step/facial-recognition-step.component';

@Component({
  selector: 'fgb-facial-recognition-stepper',
  templateUrl: './facial-recognition-stepper.component.html',
  styleUrl: './facial-recognition-stepper.component.scss',
})
export class FacialRecognitionStepperComponent {
  private currentStep: number = 1;
  private internalSteps: QueryList<FacialRecognitionStepComponent>;

  @Input() counter = 1;
  @Output() counterChange = new EventEmitter<number>();

  ngOnChanges() {
    this.currentStep = this.counter;
    if (this.internalSteps) {
      this.setChildSteps();
    }
  }

  @ContentChildren(FacialRecognitionStepComponent)
  set stepsContent(steps: QueryList<FacialRecognitionStepComponent>) {
    if (steps) {
      this.internalSteps = steps;
      this.internalSteps.last.isLast = true;
      this.internalSteps.first.isFirst = true;
      this.registerSteps();
    }
  }

  nextStep() {
    this.counter++;
    this.counterChange.emit(this.counter);
  }

  prevStep() {
    this.counter--;
    this.counterChange.emit(this.counter);
  }

  setStep(step: number) {
    this.counterChange.emit(step);
  }

  private registerSteps(): void {
    this.internalSteps.toArray().forEach((step: FacialRecognitionStepComponent, idx: number) => {
      step.currentStep = this.currentStep;
      step.stepNumber = idx + 1;
    });
  }

  private setChildSteps(): void {
    this.internalSteps.toArray().forEach((step: FacialRecognitionStepComponent) => {
      step.currentStep = this.currentStep;
    });
  }
}
